<div class="mt-4 w-full">
  <thera-client-side-list
  class="w-full custom-column-spacing"
  [hideGridLines]="true"
  [columnDefs]="columnDefs"
  [rowData]="rowData">
</thera-client-side-list>
</div>
